import request from '@/utils/request'
// 获取表格列表数据
export function getList(params) {
  return request({
    url: '/report_form/predit/day',
    method: 'get',
    params
  })
}
// 公众号列表搜索框
export function getWechatAccounts(params) {
  return request({
    url: '/novel_management/wechat_accounts',
    method: 'get',
    params
  })
}
// 小说列表
export function getNovels(params) {
  return request({
    url: '/novel_management/novels',
    method: 'get',
    params
  })
}
// 筛选条件列表
export function getSelectList() {
  return request({
    url: '/novel_management/novel_report_selects',
    method: 'get'
  })
}
// 更改账号成本
export function modifyCost(params) {
  return request({
    url: '/report_form/cost/modify',
    method: 'post',
    params
  })
}

// 日预测（公众号组）
export function getDaygroup(params) {
  return request({
    url: '/report_form/predit/day_group',
    method: 'get',
    params
  })
}
// 报表导出（公众号组）
export function exportGroup(params) {
  return request({
    url: '/report_form/export/day_group',
    method: 'post',
    params
  })
}
